var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThcv = function SvgThcv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "0 0 14 17.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 .74 7 5.37v5.78l-7 5.37-7-5.37V6.11zM2 7.096v3.808l5 3.836 5-3.836V7.096L7 3.26z"
  })));
};
export default SvgThcv;